import { hide, show } from "../../utils/vanilla";
import Spinner from "../../utils/spinner";
import Trip from "../../model/Trip";
import { IAddressSearch } from "../../sync/common";
import { DriveStore } from "../../store/reducers";
import { ICachedAddress } from "../../store/data/types";
import { LocalizerService } from "../../utils/localizer";


export function toggleSpinner(spinner: Spinner | null, start: boolean, spinnerElement: string, contentElement: string, loadingElement: string) {
    let spinnerContainer = document.getElementById(spinnerElement);
    let contentContainer = document.getElementById(contentElement);

    if (start) {
        spinnerContainer && show(spinnerContainer);
        let loading = document.querySelector(loadingElement) as HTMLElement;
        loading && spinner?.spin(loading);
        contentContainer && hide(contentContainer);
        return;
    }
    spinner?.stop();
    spinnerContainer && hide(spinnerContainer);
    contentContainer && show(contentContainer);
}

export function tripListToIAddressSearchList(trips: Trip[]): IAddressSearch[] {
    let addresses: IAddressSearch[] = [];

    trips.forEach(trip => {
        if (trip._startPoint) {
            addresses.push({
                id: trip.id,
                coordinate: trip._startPoint
            });
        }

        if (trip.stopPoint) {
            addresses.push({
                id: trip.id,
                coordinate: trip.stopPoint
            });
        }
    });
    return addresses;
}

export function splitAddress(formattedAddress?: string) {
    return (formattedAddress || "").split(",");
}

export function getAddressFromRedux(store: DriveStore, address: ICoordinate): ICachedAddress {
    let addressCache = store.getState().data.addressCache;
    return addressCache[`${ address.x.toFixed(4) }__${ address.y.toFixed(4) }`];
}

export function convertToLocalDistanceString(localizerService: LocalizerService, distance?: number) {
    return localizerService.toLocalDistanceString((distance || 0) * 1000);
}